<script>
export default {
  name: 'DescriptionListGroup',

  functional: true,

  props: {
    label: {
      type: [Number, String],
      required: false,
      default: null,
    },

    mandatory: {
      type: Boolean,
      required: false,
    },
  },

  render: (h, ctx) => {
    const { label, mandatory } = ctx.props;

    if (mandatory || ctx.children || ctx.scopedSlots?.default) {
      if (!mandatory && ctx.children && !ctx.children[0].tag && !ctx.children[0].children && !ctx.children[0].text?.trim()) return null;

      const items = [];
      if (ctx.children) items.push(...ctx.children);
      else {
        items.push(...ctx.scopedSlots.default());
      }

      return [
        h('dt', { staticClass: 'header', domProps: { innerHTML: ctx.parent.$to(label) } }),
        h('dd', { staticClass: 'grouped' }, [h('dl', { staticClass: 'dl1' }, items)]),
      ];
    }

    return null;
  },
};
</script>

<style scoped lang="scss">
@import '~@scss';

dt.header {
  padding-top: 12px;
  padding-bottom: 6px;
  font-size: 21px;
  font-weight: 300;
  color: $color-gray;
  border-bottom: 1px solid $color-border-bright;

  &:first-of-type {
    padding-top: 0;
  }
}
dd.grouped {
  width: 100%;
  margin: 0;
  color: $color-gray-darker;

  > dl {
    margin: 0;
  }
}
</style>
